<div class="d-flex flex-column justify-content-between h-100 siteDownPage">
  <img [id]="logoParams.logoId" [src]="logoParams.logoUrl" [alt]="logoParams.logoAltText">
  <section class="d-flex flex-column h-100 siteDownBody">
    <zbp-icon [iconName]="zbpIconNames.wrenches" iconSize="default"></zbp-icon>
    <header class="text-center">
      <div class="siteDownTitle" [innerHTML]="title"></div>
    </header>
    <article class="text-center siteDownMessage" [innerHTML]="message"></article>
    <a *ngIf="isZB" class="d-block ps-1 backToZanerBloserLink text-link" [attr.href]="zbLink">Return to Zaner-Bloser.com</a>
  </section>
  <zbp-footer [hoverColor]="footerItemHoverColor"></zbp-footer>
</div>
